export default __webpack_public_path__ + "static/media/CalendarAddIcon.3a52d8ae.svg";